<template>
    <v-container>
        <v-form ref="form">
            <v-row>
                <h2 class="pb-5">
                    {{ this.parentObject.pageTitle
                    }}<span class="page_title_value">{{
                        this.parentObject.pageTitleValue
                    }}</span>
                </h2>
            </v-row>

            <v-container
                id="scroll-target"
                class="custom-form overflow-y-auto px-5"
            >
                <v-row>
                    <v-col cols="4" sm="4" class="pb-n5">
                        <v-text-field
                            outlined
                            :label="this.$t('arrearsexercise.bpexercisecode')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.bpexercisecode"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="10" sm="10" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('arrearsexercise.bpexercisedesc')"
                            type="text"
                            :rules="[rules.required]"
                            v-model="formData.bpexercisedesc"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('arrearsexercise.inceffdate')"
                            type="date"
                            :rules="[rules.required]"
                            v-model="formData.inceffdate"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('arrearsexercise.actinceffdate')"
                            type="date"
                            :rules="[rules.required]"
                            v-model="formData.actinceffdate"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n5 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('arrearsexercise.servicedate')"
                            type="date"
                            :rules="[rules.required]"
                            v-model="formData.servicedate"
                            @input="updateValue"
                            dense
                        ></v-text-field>
                    </v-col>
                    <v-col cols="3" sm="3" class="pb-n5 mt-n8">
                    <v-checkbox
                        :label="this.$t('arrearsexercise.posted')"
                        v-model="formData.posted"
                        input-value="true"
                        disabled
                    >
                    </v-checkbox
                    ></v-col>
                </v-row>

                <v-row>
                    <v-col cols="6" sm="6" class="pb-n5 mt-n8">
                        <v-autocomplete
                        outlined
                        :label="this.$t('statutoryexportcommonused.payoutdescription')"
                        type="text"
                        clearable
                        :items="payoutcodesList"
                        :rules="[rules.required]"
                        v-model="formData.posttopayoutid"
                        @change="changePayoutHandler(formData.posttopayoutid)"
                        @input="updateValue"
                        dense
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field
                        dense
                        :label="this.$t('columns.code')"
                        outlined
                        readonly
                        background-color="#ffeab2"
                        v-model="formData.posttopayoutcode"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <v-row>
                <v-col cols="12" sm="12" class="pb-n5 mt-n8">
                    <v-tabs>
                    <v-tab>{{$t('arrearsexercise.exercisepo')}}</v-tab>
                    <v-tab>{{$t('arrearsexercise.exercisepayitem')}}</v-tab>
                    <v-tab>{{$t('arrearsexercise.exercisestatpayitem')}}</v-tab>
                    <v-tab>{{$t('arrearsexercise.exercisectrl')}}</v-tab>

                    <v-tab-item>
                        <v-row class="mt-8">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n8">
                            <app-table
                                v-bind:parentObject="{
                                    tabHeader: this.tabExercisepo,
                                    detailItem: this.formData.exercisepo,
                                    formTitle: `${$t('arrearsexercise.exercisepo')}`,
                                    formId: 'exercisepo',
                                }"
                                v-on:input="addPOHandler"
                            />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="mt-8">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n8">
                            <app-table
                                v-bind:parentObject="{
                                    tabHeader: this.tabExercisepayitem,
                                    detailItem: this.formData.exercisepayitem,
                                    formTitle: `${$t('arrearsexercise.exercisepayitem')}`,
                                    formId: 'exercisepayitem',
                                }"
                                v-on:input="addPayitemHandler"
                            />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="mt-8">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n8">
                            <app-table
                                v-bind:parentObject="{
                                    tabHeader: this.tabExercisestatpayitem,
                                    detailItem: this.formData.exercisestatpayitem,
                                    formTitle: `${$t('arrearsexercise.exercisestatpayitem')}`,
                                    formId: 'exercisestatpayitem',
                                }"
                                v-on:input="addStatPayitemHandler"
                            />
                            </v-col>
                        </v-row>
                    </v-tab-item>

                    <v-tab-item>
                        <v-row class="mt-8 ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n8">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.dedtallw')"
                                    v-model="formData.exercisectrl.dedtallw"
                                    @change="changeDedtallw(formData.exercisectrl.dedtallw)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n10">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.dedtot')"
                                    v-model="formData.exercisectrl.dedtot"
                                    @change="changeDedtot(formData.exercisectrl.dedtot)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n10">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.dedtbon')"
                                    v-model="formData.exercisectrl.dedtbon"
                                    @change="changeDedtbon(formData.exercisectrl.dedtbon)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n10">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.dedtbasic')"
                                    v-model="formData.exercisectrl.dedtbasic"
                                    @change="changeDedtbasic(formData.exercisectrl.dedtbasic)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row class="ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n10">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.dedtdedt')"
                                    v-model="formData.exercisectrl.dedtdedt"
                                    @change="changeDedtdedt(formData.exercisectrl.dedtdedt)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row>
                        <!-- <v-row class="ml-10">
                            <v-col col="12" sm="12" class="pb4-n4 mt-n10">
                                <v-checkbox
                                    :label="this.$t('arrearsexercise.paydedt')"
                                    v-model="formData.exercisectrl.paydedt"
                                    @change="changePaydedt(formData.exercisectrl.paydedt)"
                                    input-value="true"
                                    @input="updateValue"
                                >
                                </v-checkbox>
                            </v-col>
                        </v-row> -->
                    </v-tab-item>
                    </v-tabs>
                </v-col>
                </v-row>
            </v-container>


            <app-formbuttons
                v-bind:EditBool="this.parentObject.isEdit"
                v-on:NewPressed="newHandler"
                v-on:SavePressed="saveHandler"
                v-on:DeletePressed="deleteHandler"
                v-on:CancelPressed="cancelHandler"
            />
        </v-form>

    </v-container>
</template>

<script>
import CRUDTable from "./CRUDTable";
// import moment from "moment";

export default {
    props: {
        parentObject: Object,
    },

    components: {
    "app-table": CRUDTable,
    },
    data() {
        return {
            rules: {
                required: (value) => !!value || this.$t('reportsparam.required'),
                email: (value) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Invalid e-mail.";
                },
            },
            currencyCode: null,

            formData: {
                bpexercisecode: this.parentObject.data.bpexercisecode,
                bpexercisedesc: this.parentObject.data.bpexercisedesc,
                inceffdate: this.parentObject.data.inceffdate,
                actinceffdate: this.parentObject.data.actinceffdate,
                servicedate: this.parentObject.data.servicedate,
                posttopayoutid: this.parentObject.data.posttopayoutid,
                posttopayoutcode: this.parentObject.data.posttopayoutcode,
                posted: this.parentObject.data.posted,
                exercisepo: this.parentObject.data.exercisepo,
                exercisepayitem: this.parentObject.data.exercisepayitem,
                exercisestatpayitem: this.parentObject.data.exercisestatpayitem,
                exercisectrl: this.parentObject.data.exercisectrl,
                stamp: this.parentObject.data.stamp,
                userid: this.parentObject.data.userId,
            },
            subDialogPO: false,
            subDialogPayitem: false,
            tabExercisepo: [
                { text: this.$t('columns.actions'), value: "action", sortable: false, width: "100px" },
                { text: this.$t('arrearsexercise.payout'), value: "oripocode", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.payoutdesc'), value: "oripodesc", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.oripoyear'), value: "oripoyear", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.oripomth'), value: "oripomth", width: "50px", sortable: false },
                { text: this.$t('arrearsexercise.oripostartdate'), value: "oripostartdate", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.oripoenddate'), value: "oripoenddate", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.oripopytypedesc'), value: "oripopytypedesc", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.oripopygroupdesc'), value: "oripopygroupdesc", width: "200px", sortable: false },
            ],
            tabExercisepayitem: [
                { text: this.$t('columns.actions'), value: "action", sortable: false, width: "100px" },
                { text: this.$t('arrearsexercise.payitemcatcode'), value: "oripayitemcatcode", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.payitemcatdesc'), value: "oripayitemcatdesc", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.topaypayitemcode'), value: "topaypayitemcode", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.topaypayitemdesc'), value: "topaypayitemdesc", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.todedtpayitemcode'), value: "todedtpayitemcode", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.todedtpayitemdesc'), value: "todedtpayitemdesc", width: "200px", sortable: false },
            ],
            tabExercisestatpayitem: [
                { text: this.$t('columns.actions'), value: "action", sortable: false, width: "100px" },
                { text: this.$t('arrearsexercise.oripayitemcode'), value: "oripayitemcode", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.oripayitemdesc'), value: "oripayitemdesc", width: "200px", sortable: false },
                { text: this.$t('arrearsexercise.arrpayitemcode'), value: "topaypayitemcode", width: "100px", sortable: false },
                { text: this.$t('arrearsexercise.arrpayitemdesc'), value: "topaypayitemdesc", width: "200px", sortable: false },
            ],
            payoutcodesList:[],
            payoutcodes:[],
            
            payoutsList:[],
            payouts:[],
            
            errMsg: "",
            isErr: false,
            search: this.parentObject.searchnew
        };
    },
    methods: {
        updateValue() {
            this.$emit("input", {
                id: this.formData.id,
                bpexercisecode: this.formData.bpexercisecode,
                bpexercisedesc: this.formData.bpexercisedesc,
                inceffdate: this.formData.inceffdate,
                actinceffdate: this.formData.actinceffdate,
                servicedate: this.formData.servicedate,
                posttopayoutid: this.formData.posttopayoutid,
                posttopayoutcode: this.formData.posttopayoutcode,
                posted: this.formData.posted,
                exercisepo: this.formData.exercisepo,
                exercisepayitem: this.formData.exercisepayitem,
                exercisestatpayitem: this.formData.exercisestatpayitem,
                exercisectrl: this.formData.exercisectrl,
                userid: this.$store.getters.userId,
            });
        },

        loadPayoutCode(){
            const vm = this;
            this.$store.dispatch('get', {
                url: '/payoutctrl/all'})
                .then(res => {
                    vm.payoutcodes = res.data.rec;
                    vm.payouts = res.data.rec;
                for (let i = 0; i < res.data.rec.length; i++) {
                    vm.payoutcodesList.push(
                    {
                        text: res.data.rec[i].payoutdesc,
                        value: res.data.rec[i].id
                    }
                    )
                }
                if (vm.formData.posttopayoutid) {
                    vm.changePayoutHandler(vm.formData.posttopayoutid);
                }
                })
                .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            });
        },

        changePayoutHandler(id) {
            let item = this.payoutcodes.find(item => item.id === id);
            this.formData.posttopayoutcode = item.payoutcode;
        },


        newHandler() {
            this.$emit("new");
        },

        saveHandler() {
            if (this.$refs.form.validate()) {
                this.$emit("save");
            }
        },

        deleteHandler() {
            this.$emit("delete");
        },

        cancelHandler() {
            this.$router.push({ name: "arrearsexerciselist" , params: { search: this.search}});
        },

        closeHandler() {
            this.subDialogPO = false;
            this.subDialogPayitem = false;
            this.isErr = !this.isErr;
            this.errMsg = "";
        },
        
        addPOHandler($event) {
            this.formData.exercisepo = $event;
            this.updateValue();
        },
        
        addPayitemHandler($event) {
            this.formData.exercisepayitem = $event;
            this.updateValue();
        },
        addStatPayitemHandler($event) {
            this.formData.exercisestatpayitem = $event;
            this.updateValue();
        },
        changeDedtallw($event) {
            this.formData.exercisectrl.dedtallw = $event;
        },
        changeDedtot($event) {
            this.formData.exercisectrl.dedtot = $event;
        },
        changeDedtbon($event) {
            this.formData.exercisectrl.dedtbon = $event;
        },
        changeDedtbasic($event) {
            this.formData.exercisectrl.dedtbasic = $event;
        },
        changeDedtdedt($event) {
            this.formData.exercisectrl.dedtdedt = $event;
        },
        changePaydedt($event) {
            this.formData.exercisectrl.paydedt = $event;
        },
    },

    mounted() {
        this.loadPayoutCode();
    },
};
</script>

<style scoped>
</style>